import { CommonSchemaIds } from "./common.const.js";
import { UserSchemaIds, UserTags } from "./user.const.js";
export const USER_TLMD_SCHEMAS = {
    [UserSchemaIds.USER]: {
        id: UserSchemaIds.USER,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            _id: {
                ref: CommonSchemaIds.UUID,
                required: true,
                usage: [],
            },
            title: {
                ref: CommonSchemaIds.TITLE,
                required: true,
                usage: [],
            },
            locale: {
                ref: CommonSchemaIds.LOCALE,
                required: true,
                usage: [],
            },
            reseller: {
                ref: CommonSchemaIds.RESELLER,
                required: false,
                usage: [],
            },
            roles: {
                ref: CommonSchemaIds.ROLES,
                required: true,
                usage: [],
            },
            active: {
                ref: CommonSchemaIds.ACTIVE,
                required: true,
                usage: [],
            },
            deleted: {
                ref: CommonSchemaIds.DELETED,
                required: true,
                usage: [],
            },
        }
    },
    [UserSchemaIds.USER_WITH_EMAIL]: {
        id: UserSchemaIds.USER_WITH_EMAIL,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            _id: {
                ref: CommonSchemaIds.UUID,
                required: true,
                usage: [
                    UserTags.TEAM,
                    UserTags.DOMAIN,
                    UserTags.ACCOUNT_AS_TEAM,
                    UserTags.ACCOUNT_AS_ACCOUNT,
                    { tag: UserTags.MEMBER_AS_TEAM, input: { read: 0, update: 0 } },
                    { tag: UserTags.MEMBER_AS_ACCOUNT, input: { read: 0, update: 0 } },
                ],
            },
            title: {
                ref: CommonSchemaIds.TITLE,
                required: true,
                usage: [
                    { tag: UserTags.TEAM },
                    { tag: UserTags.DOMAIN },
                    { tag: UserTags.ACCOUNT_AS_TEAM },
                    { tag: UserTags.ACCOUNT_AS_ACCOUNT },
                    { tag: UserTags.MEMBER_AS_TEAM, input: { read: -1, update: -1 } },
                    { tag: UserTags.MEMBER_AS_ACCOUNT, input: { read: -1, update: -1 } },
                ],
            },
            locale: {
                ref: CommonSchemaIds.LOCALE,
                required: true,
                usage: [
                    { tag: UserTags.TEAM },
                    { tag: UserTags.DOMAIN },
                    { tag: UserTags.ACCOUNT_AS_TEAM },
                    { tag: UserTags.ACCOUNT_AS_ACCOUNT },
                    { tag: UserTags.MEMBER_AS_TEAM, input: { read: 1, update: 1 } },
                    { tag: UserTags.MEMBER_AS_ACCOUNT, input: { read: 1, update: 1 } },
                ],
            },
            reseller: {
                ref: CommonSchemaIds.RESELLER,
                required: false,
                usage: [
                    UserTags.TEAM,
                    UserTags.DOMAIN,
                    { tag: UserTags.ACCOUNT_AS_TEAM },
                    { tag: UserTags.ACCOUNT_AS_ACCOUNT, input: -1 },
                    { tag: UserTags.MEMBER_AS_TEAM, input: { read: 0, update: 0 } },
                    { tag: UserTags.MEMBER_AS_ACCOUNT, input: { read: 0, update: 0 } },
                ],
            },
            roles: {
                ref: CommonSchemaIds.ROLES,
                required: true,
                usage: [
                    { tag: UserTags.TEAM, ref: CommonSchemaIds.SYSTEM_ADMIN_ROLES },
                    { tag: UserTags.DOMAIN },
                    UserTags.ACCOUNT_AS_TEAM,
                    UserTags.ACCOUNT_AS_ACCOUNT,
                    { tag: UserTags.MEMBER_AS_TEAM, input: { read: -1, update: -1 } },
                    { tag: UserTags.MEMBER_AS_ACCOUNT, input: { read: -1, update: -1 } },
                ],
            },
            email: {
                ref: CommonSchemaIds.EMAIL,
                required: true,
                usage: [
                    { tag: UserTags.TEAM, input: { create: 1, read: -1, update: -1 } },
                    { tag: UserTags.DOMAIN, input: { create: 1, read: -1, update: -1 } },
                    { tag: UserTags.ACCOUNT_AS_TEAM, input: { create: 1, read: -1, update: -1 } },
                    { tag: UserTags.ACCOUNT_AS_ACCOUNT, input: { create: 1, read: -1, update: -1 } },
                    { tag: UserTags.MEMBER_AS_TEAM, input: { read: 0, update: 0 } },
                    { tag: UserTags.MEMBER_AS_ACCOUNT, input: { read: 0, update: 0 } },
                ],
            },
            active: {
                ref: CommonSchemaIds.ACTIVE,
                required: true,
                usage: [
                    { tag: UserTags.TEAM, input: { create: -1, read: 1, update: 1 } },
                    { tag: UserTags.DOMAIN, input: { create: -1, read: 1, update: 1 } },
                    { tag: UserTags.ACCOUNT_AS_TEAM, input: { create: -1, read: 1, update: 1 } },
                    { tag: UserTags.ACCOUNT_AS_ACCOUNT, input: { create: -1, read: 1, update: 1 } },
                    { tag: UserTags.MEMBER_AS_TEAM, input: { read: 1, update: 1 } },
                    { tag: UserTags.MEMBER_AS_ACCOUNT, input: { read: 1, update: 1 } },
                ],
            },
            deleted: {
                ref: CommonSchemaIds.DELETED,
                required: true,
                usage: [
                    { tag: UserTags.TEAM, input: { create: -1, read: 1, update: 1 } },
                    { tag: UserTags.DOMAIN, input: { create: -1, read: 1, update: 1 } },
                    { tag: UserTags.ACCOUNT_AS_TEAM, input: { create: -1, read: 1, update: 1 } },
                    { tag: UserTags.ACCOUNT_AS_ACCOUNT, input: { create: -1, read: 1, update: 1 } },
                    { tag: UserTags.MEMBER_AS_TEAM, input: { read: 1, update: 1 } },
                    { tag: UserTags.MEMBER_AS_ACCOUNT, input: { read: -1, update: -1 } },
                ],
            },
        }
    },
    [UserSchemaIds.CREATE_MEMBER]: {
        id: UserSchemaIds.CREATE_MEMBER,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            email: {
                ref: CommonSchemaIds.EMAIL,
                required: true,
                usage: [{ tag: UserTags.DEFAULT, input: { create: 1 } }],
            },
            secret: {
                ref: CommonSchemaIds.SECRET,
                required: true,
                usage: [{ tag: UserTags.DEFAULT, input: { create: 2 } }],
            },
            locale: {
                ref: CommonSchemaIds.LOCALE,
                required: true,
                usage: [{ tag: UserTags.DEFAULT, input: { create: 1 } }],
            },
        }
    },
    [UserSchemaIds.USER_PROFILE]: {
        id: UserSchemaIds.USER_PROFILE,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            title: {
                ref: CommonSchemaIds.TITLE,
                required: true,
                usage: [{ tag: UserTags.DEFAULT, input: { update: 1 } }],
            },
            locale: {
                ref: CommonSchemaIds.LOCALE,
                required: true,
                usage: [{ tag: UserTags.DEFAULT, input: { update: 1 } }],
            },
        }
    },
    [UserSchemaIds.MEMBER_PROFILE]: {
        id: UserSchemaIds.MEMBER_PROFILE,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            locale: {
                ref: CommonSchemaIds.LOCALE,
                required: true,
                usage: [{ tag: UserTags.DEFAULT, input: { update: 1 } }],
            },
        }
    },
};
